import * as React from 'react';
import { Navbar, Nav, NavDropdown, Dropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Auth } from 'aws-amplify';
import { NavigationButtons } from './NavigationButtons';
import { inject, observer } from 'mobx-react';
import { UserProfileUIStore } from './stores/user-profile-ui-store';
import { GenericModal } from './components/common/generic-modal';

type State = {
  currentUsername: string;
  showUpgradeModal: boolean;
};

interface NavigationProps {
  userProfileUIStore?: UserProfileUIStore;
}

// TODO: Figure out how we can just use the currentUser on the UserStore instead of
// what we are doing here with currentUsername
@inject('userProfileUIStore')
@observer
export class Navigation extends React.Component<NavigationProps, State> {
  state: State = {
    currentUsername: '',
    showUpgradeModal: false,
  };

  componentDidMount() {
    this.obtainCurrentUsername();
    // Load user profile for menu rendering
    const { userProfileUIStore } = this.props;
    if (userProfileUIStore && !userProfileUIStore.currentUserProfile) {
      userProfileUIStore.loadCurrentUserProfile();
    }
  }

  obtainCurrentUsername = async () => {
    console.log('calling Auth.currentSession()');
    const session: any = await Auth.currentSession();
    console.log(session);
    const currentUsername = session.idToken.payload.given_name
      ? `${session.idToken.payload.given_name} ${session.idToken.payload.family_name}`
      : session.idToken.payload.email;
    this.setState({
      currentUsername,
    });
  };

  signOut = () => {
    Auth.signOut().then(() => {
      window.location.reload();
    });
  };

  handleUpgradeClick = () => {
    this.setState({ showUpgradeModal: true });
  };

  renderCustomLogoMenuItem = () => {
    const { userProfileUIStore } = this.props;
    const userProfile = userProfileUIStore?.currentUserProfile;

    if (!userProfile) {
      return null;
    }

    if (userProfile.canUploadCustomLogo()) {
      return (
        <LinkContainer exact to="/logo/upload">
          <Dropdown.Item>Add Custom Logo</Dropdown.Item>
        </LinkContainer>
      );
    } else {
      return (
        <Dropdown.Item onClick={this.handleUpgradeClick}>
          Add Custom Logo
        </Dropdown.Item>
      );
    }
  };

  render() {
    const { currentUsername, showUpgradeModal } = this.state;
    return (
      <div>
        <Navbar bg="dark" variant="dark" collapseOnSelect>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse>
            <Nav>
              <Nav.Item>
                <Nav.Link href="/">Home</Nav.Link>
              </Nav.Item>
              <NavDropdown title="Clients" id="clients-nav-dropdown">
                <LinkContainer exact to="/client/add">
                  <Dropdown.Item>Add Client</Dropdown.Item>
                </LinkContainer>
                <LinkContainer exact to="/client/edit/manage">
                  <Dropdown.Item>Manage Clients</Dropdown.Item>
                </LinkContainer>
              </NavDropdown>

              <NavDropdown title="Test Results" id="test-results-nav-dropdown">
                <LinkContainer exact to="/bloodwork/add">
                  <Dropdown.Item>Add Test Results</Dropdown.Item>
                </LinkContainer>
                <LinkContainer exact to="/bloodwork/analyze">
                  <Dropdown.Item>Manage Test Results</Dropdown.Item>
                </LinkContainer>
              </NavDropdown>

              <NavDropdown title="Help" id="help-nav-dropdown">
                <Dropdown.Item
                  href="https://labsmarts.com/resources"
                  target="_blank"
                >
                  Resources
                </Dropdown.Item>
                <Dropdown.Item
                  href="mailto:support@labsmarts.com"
                  target="_blank"
                >
                  Support
                </Dropdown.Item>
              </NavDropdown>

              <NavDropdown title={currentUsername} id="misc-nav-dropdown">
                <Dropdown.Item
                  href="https://labsmarts.com/my-account"
                  target="_blank"
                >
                  Manage Subscription
                </Dropdown.Item>
                {this.renderCustomLogoMenuItem()}
                <Dropdown.Item onClick={this.signOut}>Signout</Dropdown.Item>
              </NavDropdown>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <NavigationButtons />

        <GenericModal
          show={showUpgradeModal}
          title="Custom Logo Feature Not Available"
          text="Custom Logo feature not enabled."
          link="https://labsmarts.com/custom-logo-upgrade"
          linkText="Click here to upgrade."
          onHide={() => this.setState({ showUpgradeModal: false })}
        />
      </div>
    );
  }
}
